// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1JHDx","label":"LabeledBox_label__3qoMs"};